import { createContext } from 'react'

const northcapitalContext = createContext()

export default northcapitalContext
